import { Segmented } from 'antd';

import {
  type LeadsRegistryChatScopeValue,
  useLeadsRegistryChatScopeFilter,
} from '../hooks/useLeadsRegistryChatScopeFilter';

import type { LeadsRegistryFilterScope } from '../../../../model/types';
import type { FC } from 'react';

import './LeadsRegistryChatScopeFilter.scss';

interface LeadsRegistryChatScopeFilterProps {
  filterScope?: LeadsRegistryFilterScope;
}

export const LeadsRegistryChatScopeFilter: FC<
  LeadsRegistryChatScopeFilterProps
> = ({ filterScope = 'registry' }) => {
  const { options, value, onChange } =
    useLeadsRegistryChatScopeFilter(filterScope);

  return (
    <Segmented<LeadsRegistryChatScopeValue>
      className="LeadsRegistryChatScopeFilter"
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};
